import { Alert, Button, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AuthPageLayout from './AuthPageLayout';
import { verifyEmailToken } from './LoginUtils';

export default function VerifyEmail() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('loading');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) {
            setStatus('error');
            setMessage('Verification link is invalid.');
            return;
        }
        verifyEmailToken(token)
            .then((result) => {
                setStatus('success');
                setMessage(result.message);
            })
            .catch((err) => {
                setStatus('error');
                setMessage(err.message);
            });
    }, [searchParams]);

    return (
        <AuthPageLayout title="Verify your email">
            {status === 'loading' && <CircularProgress />}
            {status === 'success' && (
                <>
                    <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>
                    <Button variant="contained" onClick={() => navigate('/mycases')}>
                        Sign in
                    </Button>
                </>
            )}
            {status === 'error' && (
                <>
                    <Alert severity="error" sx={{ mb: 2 }}>{message}</Alert>
                    <Button variant="outlined" onClick={() => navigate('/mycases')}>
                        Back to sign in
                    </Button>
                </>
            )}
        </AuthPageLayout>
    );
}
